module.exports = __webpack_public_path__ + "static/media/edco-thumb.5538e9f8.png";